// extracted by css-extract-rspack-plugin
export default {"actions":"actions-eiyzXN","action":"action-gDAvHO","row":"row-tkCzil"};